export default __webpack_public_path__ + "static/media/Page2.367511df.svg";